var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('guard',{attrs:{"if-admin":_vm.getGuardFuncionalities}},[_c('is-loading',{attrs:{"if":_vm.isLoading,"centered":true}},[_c('has-request-error',{attrs:{"has-error":_vm.requestError,"is-loading":_vm.isReloading && _vm.requestError},on:{"retry":_vm.reloadData}},[_c('div',[(_vm.categoriesWithProducts.length && !_vm.isDisabled)?_c('p',{staticClass:"has-margin-top-100 has-text-right"},[_c('a',{staticClass:"button is-dark is-rounded",attrs:{"disabled":_vm.isProcessing},on:{"click":_vm.openManageProductsModal}},[_vm._v("\n            "+_vm._s(_vm.$t("_action.manage"))+"\n          ")])]):_vm._e(),_vm._v(" "),_c('multilevel-sortable-list',{key:_vm.listKey,attrs:{"initial-data":_vm.categoriesWithProducts,"sortable-item-name":_vm.$t(
              _vm.isOption
                ? '_.product_options'
                : _vm.isAttribute
                ? '_.product_attributes'
                : '_.products'
            ),"item-name":_vm.$t(
              _vm.isOption
                ? '_.product_option'
                : _vm.isAttribute
                ? '_.product_attribute'
                : '_.product'
            ),"type":_vm.isOption
              ? 'product_options'
              : _vm.isAttribute
              ? 'product_attributes'
              : 'products',"is-processing":_vm.isProcessing,"is-disabled":_vm.isDisabled,"detach":_vm.detach,"scope":'selections',"view":_vm.view,"lock-to-parent":true,"is-item-clickable":false,"reorder":_vm.reorder}},[_c('template',{slot:"empty"},[_c('no-results',{attrs:{"icon":"exclamation-circle","title":_vm.i18n.emptyResultsTitle,"message":_vm.i18n.emptyResultsMsg,"cta":_vm.isDisabled
                  ? {}
                  : {
                      label: _vm.$t('_action.manage'),
                      class: 'is-outlined'
                    }},on:{"click":_vm.openManageProductsModal}})],1)],2)],1)])],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }